export const getServiceAreasFrag = `
    id
    name
    description
    mpsvRegion
`;

export const getTargetsFrag = `
    targets {
        id
        name
    }
`;

export const getProjectsFrag = `
    id
    name
`;
